module.exports = __webpack_public_path__ + "img/932-14ba62.png";